<template>
  <div :id="id"></div>
</template>


<script>
import * as echarts from "echarts/core";
import { LineChart } from "echarts/charts";
import {
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  LineChart,
  CanvasRenderer,
  TooltipComponent,
  GridComponent,
  LegendComponent,
]);
export default {
  props: {
    id: {
      type: String,
      default: "flow-line-chart",
    },
    list: {
      type: Array,
      default: () => [],
    },
  },

  watch: {
    list() {
      this.renderChart();
    },
  },

  mounted() {
    var chartDom = document.getElementById(this.id);
    chartDom.style.height = "30vh";
    chartDom.style.width = "28vw";
    this.chart = echarts.init(chartDom);
    this.renderChart();
  },

  methods: {
    renderChart() {
      var option = {
        legend: {
          show: true,
          textStyle: {
              color: '#fff',
          },
        },

        xAxis: {
          type: "category",
          data: this.list.map((item) => item.ts),
          splitLine: {
            show: true,
          },
          axisLine: {
            show: true,
            textStyle: {
                color: '#fff',
            },
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
          },
          axisLabel: {
            textStyle: {
                color: '#fff',
            },
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          textStyle: {
              color: '#fff',
          },
        },

        grid: {
          show: false,
          left: "10%",
          top: "10%",
          right: "0%",
          bottom: "15%",
        },

        series: [
          {
            name: "液位",
            type: "line",
            smooth: true,
            data: this.list.map((item) => item.liquidLevel),
          },
          {
            name: "流速",
            type: "line",
            smooth: true,
            data: this.list.map((item) => item.flowspeed),
          },
          {
            name: "温度",
            type: "line",
            smooth: true,
            data: this.list.map((item) => item.temperature),
          },
        ],
      };
      option && this.chart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped></style>